import React from "react";
import { Phone } from "lucide-react";
import { CALENDLY_URL } from "../i18n";
import { useLang } from "../context/LangContext";

export default function Footer() {
  const { c } = useLang();
  const f = c.footer;
  return (
    <footer style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "4rem 0 3rem", background: "#08080a" }}>
      <div className="container-x">
        <div style={{ textAlign: "center", maxWidth: 760, margin: "0 auto 3rem" }}>
          <h2 className="display" style={{ fontSize: "clamp(2rem,4vw,3rem)", marginBottom: "1.4rem" }}>{f.title.pre}<span className="italic-gold">{f.title.em}</span>{f.title.post}</h2>
          <p className="body-text" style={{ marginBottom: "2rem" }}>{f.para}</p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <a href="#contact" className="btn-gold">{f.cta1}</a>
            <a href={"tel:+15712779452"} className="btn-outline"><Phone size={15} /> {f.cta2}</a>
          </div>
        </div>

        <hr style={{ border: "none", borderTop: "1px solid rgba(255,255,255,0.06)", margin: "3rem 0 2rem" }} />

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "1.5rem" }}>
          <a href="#top" className="font-serif" style={{ fontSize: "1.4rem", textDecoration: "none" }}>
            <span style={{ color: "var(--text)" }}>DSCR</span><span style={{ color: "var(--gold)" }}>Daily</span>
          </a>
          <p style={{ color: "var(--muted-2)", fontSize: "0.75rem", maxWidth: 640, lineHeight: 1.7, margin: 0 }}>{f.disclaimer}</p>
        </div>
        <p style={{ color: "var(--muted-2)", fontSize: "0.72rem", marginTop: "2rem" }}>© {new Date().getFullYear()} DSCR Daily. {f.rights} · <a href={CALENDLY_URL} target="_blank" rel="noreferrer" className="link-hover" style={{ color: "var(--muted)", textDecoration: "none" }}>{f.privacy}</a> · <a href="#" className="link-hover" style={{ color: "var(--muted)", textDecoration: "none" }}>{f.terms}</a></p>
      </div>
    </footer>
  );
}
